module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADkSURBVHgBhZLdCoJAEIXHWduCoG67iH7epB7Fi56qCx8l36SIgq4DwdKdbY6YmFYeEHTnnN2dbwyopf1svmHiDd6FJNndLkmzHjSNYcDxmHk1YiajpVScPnIiL1FUBYO32bI5LO2QNPBx4t0VdM1zcuK2CJVV7Dwf2I4ZmpiQFtbq1hyXJ2D3qQkP6+GI/un4yCh1xZbR4JgN9Ql9iXrLOzjvewOm4oNcknnpDYAYvIzOgQ4LvwRS8NSUwPn8fGqhG0p17aJY4cF3PbhYaVE1OEBw5CkT+T64phAEjbJBvXPU+jVe1n11hUTYm6oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/done.png
// module id = 1534
// module chunks = 0